// import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import client from '../../../utils/apolloClient';

const fetchUserQuery = gql`
  query fetchUserQuery($input: NavigateUserInput) {
    fetch_user(input: $input) {
      user_id
      email
      display_name
      contact {
        type
        value
        is_primary
      }
      error {
        description
      }
    }
  }
`;

export const useUserData = ({ userId }) => {
  const { data: userData } = useQuery(fetchUserQuery, {
    variables: { input: { user_id: userId } },
    client: client.clientPrivate,
  });

  if (
    userData &&
    userData.fetch_user &&
    userData.fetch_user.display_name &&
    userData.fetch_user.email
  ) {
    return `${userData.fetch_user.display_name} (${userData.fetch_user.email})`;
  }

  return null;
};

export default {};
